<template>
  <vb-modal
    :value="show"
    class="text-left"
    @cancel="close()"
    @opened="onOpen()"
  >
    <div slot="modal-header" class="modal-header">
      <h3 class="modal-title">
        Add new startup
      </h3>
    </div>
    <div slot="modal-body" class="modal-body">
      <div v-show="!startupAdded" class="row">
        <form class="col-sm-12 col-md-10 col-md-offset-1">
          <!-- fake fields are a workaround for chrome autofill getting the wrong fields -->
          <input style="display: none;" type="text" name="email" />

          <div class="form-group">
            <input
              v-model="name"
              type="text"
              class="form-control"
              placeholder="Startup name"
              aria-describedby="name"
              autofocus
              @keyup.enter="submit()"
            />
            <p v-for="error in errors.name" :key="error" class="text-danger">
              {{ error }}
            </p>
          </div>
        </form>
      </div>

      <div v-show="inProgress" class="text-center">
        <loader />
      </div>

      <div v-show="startupAdded" class="row animated fadeInUp">
        <div class="col-sm-12">
          <p class="text-success">
            Startup added.
            <a href @click.prevent="goToStartupEditPage({ id: startupId })">
              Click here to edit
            </a>
          </p>
        </div>
      </div>
    </div>
    <div slot="modal-footer" class="modal-footer">
      <button type="button" class="btn btn-default" @click="close()">
        Close
      </button>
      <button
        v-show="!startupAdded"
        type="button"
        class="btn btn-primary"
        :disabled="inProgress"
        @click="submit()"
      >
        Create
      </button>
    </div>
  </vb-modal>
</template>

<script>
import delayRequest from 'utils/delay-request'
import http from 'services/http'

function initData() {
  return {
    startupId: null,
    name: '',
    errors: { name: [] },
    inProgress: false,
    startupAdded: false,
  }
}

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return initData()
  },
  computed: {
    hasErrors: function () {
      return this.email.length || this.password.length
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
    onOpen() {
      Object.assign(this, initData())
    },
    submit() {
      const self = this

      let request = http.postAuthed('/startups/create', {
        name: self.name,
      })
      request = delayRequest(request, 1000)

      request
        .finally(() => {
          self.inProgress = false
        })
        .then((response) => {
          self.startupAdded = true
          self.startupId = response.data.id
          self.$emit('created', response.data)
        })
        .catch((response) => {
          self.errors = response.data
          console.log(' => errors:', self.errors)
        })
    },
    goToStartupEditPage({ id }) {
      this.close()
      const self = this
      // TODO: this whole component should use our Modal.vue instead of
      // the one from vue-strap. Then we could use closeAndRedirect instead
      setTimeout(function () {
        self.$router.push({ name: 'adminStartupEdit', params: { id } })
      }, 500)
    },
  },
}
</script>

<style lang="scss">
@import '~assets/css/colors.scss';

.login-modal {
  .modal-header {
    background-color: $blue;
    color: $white;
  }
  .modal-body {
    .input-group-addon {
      font-size: 18px;
      width: 40px;
    }
  }
}
</style>
